import ClientCreate from 'components/client/ClientCreate';
import ClientDashboard from 'components/dashboard/client/ClientDashboard';
import ClientEdit from 'components/client/ClientEdit';
import ClientList from 'components/client/ClientList';
import ClientMore from 'components/client/more/ClientMore';
import ClientOverviewProfile from 'components/client/overview-profile/ClientOverviewProfile';
import ClientProfile from 'components/client/profile/ClientProfile';
import ClientPlanRequestStatus from 'components/plan/ClientPlanRequestStatus';
import ClientProgram from 'components/client/program/ClientProgram';
import JoinOrganization from 'components/organization/JoinOrganization';
import MyWellbeing from 'components/wellbeing/MyWellbeing';
import DefaultLayout from 'components/layout/DefaultLayout';
import PublicPlanDetail from 'pages/plans/PublicPlanDetail';
import SubscriptionCheckout from 'pages/checkout/SubscriptionCheckout';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const clientRoutes = [
  // Admin and trainer routes

  {
    key: 'client-create',
    exact: true,
    path: routes.createClient.path,
    component: ClientCreate,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'client-edit',
    exact: true,
    path: routes.editClient.path,
    component: ClientEdit,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'client-list',
    exact: true,
    path: routes.listClient.path,
    component: ClientList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.supervisor, roles.trainer]
  },
  {
    key: 'client-overview-profile',
    exact: true,
    path: routes.viewClient.path,
    component: ClientOverviewProfile,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.supervisor, roles.trainer]
  },

  // Client routes

  {
    key: 'client-dashboard',
    exact: true,
    path: routes.clientDashboard.path,
    component: ClientDashboard,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'client-more',
    exact: true,
    path: routes.clientMore.path,
    component: ClientMore,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'client-profile',
    exact: true,
    path: routes.clientProfile.path,
    component: ClientProfile,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'join-organization',
    exact: true,
    path: routes.joinOrganization.path,
    component: JoinOrganization,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    // Bienestar Corporativo: histórico personal del check-in (privado del usuario).
    key: 'my-wellbeing',
    exact: true,
    path: routes.myWellbeing.path,
    component: MyWellbeing,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'plan-detail',
    exact: true,
    path: routes.planDetail.path,
    component: PublicPlanDetail,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'subscription-checkout',
    exact: true,
    path: routes.subscriptionCheckout.path,
    component: SubscriptionCheckout,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'my-plan-status',
    exact: true,
    path: routes.myPlanStatus.path,
    component: ClientPlanRequestStatus,
    layout: DefaultLayout,
    allowedRoles: [roles.client]
  },
  {
    key: 'client-program',
    exact: true,
    path: routes.clientProgram.path,
    component: ClientProgram,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true
  }
];

export default clientRoutes;
